$card-image-height: 119px;

.upgradesSection {
  display: flex;
  flex: 1 1 0;
  gap: 25px;
  min-width: 0;
  width: 100%;
}

.addOnCard {
  position: relative;
  border-radius: 12px;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  background: #fff;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    border: 1px solid var(--dark-8);
    pointer-events: none;
    z-index: 1;
  }

  height: 370px;
}

.imageWrapper {
  width: 100%;
  height: $card-image-height;
  flex-shrink: 0;
  overflow: hidden;

  &.whiteLabel {
    background: linear-gradient(180deg, rgba(200, 210, 220, 0.3) 0%, rgba(200, 210, 220, 0.1) 100%);
  }

  &.extraAccounts {
    background: linear-gradient(180deg, rgba(226, 0, 50, 0.08) 0%, rgba(226, 0, 50, 0.02) 100%);
  }
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 25px;
  flex: 1;
}

.titleRow {
  display: flex;
  align-items: center;
  gap: 6px;
}

.description {
  line-height: 1.5;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px 15px 25px;
}

.priceRow {
  display: flex;
  align-items: baseline;
  gap: 4px;
}
